import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FileText } from 'lucide-react';

import { PageSeo } from '../components/PageSeo';
import { SubpageLayout } from '../components/SubpageLayout';
import { FINANCIAL_STATEMENT_PERIOD_META } from '../data/financialStatements';

/**
 * Mali tablolar — URL: /financial-statements
 */
export function FinancialStatementsPage() {
    const { t } = useTranslation();

    const periodLabels = useMemo(() => {
        const raw = t('financialStatements.periods', { returnObjects: true });
        return Array.isArray(raw) ? raw : [];
    }, [t]);

    return (
        <>
            <PageSeo
                title={`${t('financialStatements.title')} — ${t('header.rotaryAlt')}`}
                description={t('seo.financialStatements')}
            />
            <SubpageLayout
                title={t('financialStatements.title')}
                subtitle={t('financialStatements.subtitle')}
                contentClassName="financial-statements-page"
            >
            <p className="financial-statements-intro text-secondary small mb-4 mb-lg-5">
                {t('financialStatements.intro')}
            </p>
            <ul className="list-unstyled row g-3 g-md-4 mb-0">
                {periodLabels.map((label, i) => {
                    const meta = FINANCIAL_STATEMENT_PERIOD_META[i] ?? {};
                    return (
                        <li
                            key={label}
                            className="col-12 col-sm-6 col-lg-3"
                        >
                            <a
                                href={meta.href ?? '#'}
                                className="financial-statement-card h-100 d-flex flex-column align-items-start text-decoration-none"
                            >
                                <span
                                    className="financial-statement-card-icon d-inline-flex align-items-center justify-content-center flex-shrink-0"
                                    aria-hidden
                                >
                                    <FileText
                                        size={22}
                                        strokeWidth={1.75}
                                        className="financial-statement-card-icon-svg"
                                    />
                                </span>
                                <span className="financial-statement-card-label">
                                    {label}
                                </span>
                            </a>
                        </li>
                    );
                })}
            </ul>
        </SubpageLayout>
        </>
    );
}
